const getParentId = (list, key, id, parentId = null) => {
  if (Array.isArray(list)) {
    for (const child of list || []) {
      if (
        child.key === key &&
        child.id === id &&
        child.parent !== null &&
        child.parent !== undefined
      ) {
        parentId = child.parent.id;
      }
    }

    return parentId;
  }
};

export default getParentId;
